// extracted by mini-css-extract-plugin
module.exports = {"event":"_2mUtK","eventInfo":"YgfsJ","time":"_18y-3","title":"_2LA7N","chevron":"_2tjnj"};